module.exports = __webpack_public_path__ + "media/images/flags/sa-aa7287a1c446d6d0f54ca2e9e01a2ff0.svg";